import { SxProps } from "@mui/material";

export const sxInput: SxProps = {
	fontFamily: 'Unimed-Sans',
	color: '#383838',
	fontWeight: 400,
	fontSize: '14px',
	width: '100%',
	'@media (max-width: 768px)': {
		maxWidth: 'unset'
	},
	'@media (min-width: 768px) and (max-width: 899px)': {
		minWidth: '400px'
	}
}

export const sxError: SxProps = {
	color: '#D84141',
	fontSize: '12px'
}

export const sxStyleBtn: SxProps = {
	borderRadius: '80px',
	padding: '12px 32px',
	'@media (max-width: 799px)': {
		width: 'stretch',
	},
	border: 2,
	'&:focus': {
		color: 'rgb(0,0,0,0.08)',
		background: '#fff'
	},
}

export const sxLabel: SxProps = {
	fontFamily: 'Unimed-Sans',
	color: '#383838',
	fontWeight: 600,
	marginBottom: '5px'
}

export const sxButtons: SxProps = {
	width: '100%',
	display: 'flex',
	justifyContent: 'flex-start',
	gap: '20px',
	marginTop: '12px',
	'@media(max-width: 650px)': {
		flexDirection: "column-reverse"
	}
}

export const sxTitle: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontSize: '20px',
	color: '#383838',
	fontWeight: 700
}

export const sxTextField: SxProps = {
	input: {
		fontFamily: 'Unimed-Sans',
		color: '#383838',
		fontSize: '14px',
	}
}

export const sxValidationMessage: SxProps = {
	fontFamily: 'Unimed-Sans',
	color: '#D84141',
	fontSize: 12
}
